import { useReport } from './hooks/use-context';

export function Members() {
  const { header, body } = useReport();

  return (
    <div style={{ fontSize: '10px', breakInside: 'avoid' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '5fr 25fr',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '0px 5px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          Inspetor Responsável
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            borderBottom: '1px #000 solid',
          }}
        >
          <div>{header?.author_full_name}</div>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '5fr 25fr',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: '#fff',
            fontWeight: 'bold',
            padding: '0px 2px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          Membro Gestor
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '4px',
            borderBottom: '1px #000 solid',
          }}
        >
          <div>Gestor da área</div>
        </div>
      </div>
    </div>
  );
}
